import { useIsLoginPage } from "@/hooks/use-is-login-page";
import { useMemo } from "react";
import { create } from "zustand";

type SidebarState = {
  open: boolean;
};

type SidebarActions = {
  toggleOpen: () => void;
};

const _useSidebarStore = create<
  SidebarState & SidebarActions
>((set) => ({
  open: true, // TODO: do we want false as default? after all main grid view requires a lot of space + it would solve sidebar animation flash on page load when sidebar is open by default
  toggleOpen: () => set((state) => ({ open: !state.open })),
}));

export function useSidebarStore() {
  const store = _useSidebarStore();
  const disabled = useIsLoginPage();
  return useMemo(() => ({
    open: store.open, // TODO: override open as open && !disabled
    toggleOpen: store.toggleOpen,
    disabled,
  }), [store.open, store.toggleOpen, disabled]); // TODO: can I safely use store as single dep and be sure memoization work correctly here?
}